class UniversitySearch extends HTMLElement {
  constructor() {
    super();

    // Get DOM elements from the existing HTML structure
    this.searchInput = this.querySelector("#university-search-input");
    this.resultsDiv = this.querySelector("#university-results");
    this.loadingIndicator = this.querySelector("#university-loading");

    // Manage input state
    this.isInputFocused = false;
  }

  connectedCallback() {
    // Check if necessary elements exist
    if (!this.searchInput || !this.resultsDiv || !this.loadingIndicator) {
      console.error("One or more required elements were not found.");
      return;
    }

    // Add focus and blur events for input
    this.searchInput.addEventListener("focus", () => this.handleFocus());
    this.searchInput.addEventListener("blur", (event) => this.handleBlur(event));

    // Event to hide results when clicking outside input
    document.addEventListener("click", (event) => this.handleDocumentClick(event));

    // Add input event for search functionality
    this.searchInput.addEventListener("input", () => this.search());
  }

  handleFocus() {
    this.isInputFocused = true;
    if (this.resultsDiv.innerHTML !== "") this.resultsDiv.style.display = "block";
  }

  handleBlur(event) {
    this.isInputFocused = false;
    setTimeout(() => {
      if (!this.isInputFocused && !this.resultsDiv.contains(event.relatedTarget)) {
        this.resultsDiv.style.display = "none";
      }
    }, 100);
  }

  handleDocumentClick(event) {
    if (event.target !== this.searchInput && !this.resultsDiv.contains(event.target)) {
      this.resultsDiv.style.display = "none";
    }
  }

  toggleLoadingIndicator(show) {
    this.loadingIndicator.style.display = show ? "block" : "none";
  }

  search() {
    if (this.isInputFocused) this.resultsDiv.style.display = "block";
    this.toggleLoadingIndicator(true);

    setTimeout(() => {
      this.resultsDiv.innerHTML = "";
      const query = this.searchInput.value.trim().toLowerCase();

      if (!query) {
        this.toggleLoadingIndicator(false);
        return;
      }

      // Search recursively through all `names` links
      const matchedItems = this.searchLinks(names, query);

      if (matchedItems.length) {
        matchedItems.forEach(item => {
          const li = document.createElement("li");
          li.classList.add('predictive-search__list-item');

          const a = document.createElement("a");
          a.classList.add('predictive-search__item', 'link', 'link--text');
          a.textContent = item.name;
          a.href = item.url;
          li.appendChild(a);

          this.resultsDiv.appendChild(li);
        });
      } else {
        const noResultMessage = document.createElement("p");
        noResultMessage.textContent = "No Results Found";
        this.resultsDiv.appendChild(noResultMessage);
      }

      this.toggleLoadingIndicator(false);
    }, 500);
  }

  // Recursive function to search across all 3 levels of links
  searchLinks(links, query) {
    const results = [];

    links.forEach(link => {
      // Check if the link's name matches the search query
      if (link.name.toLowerCase().includes(query)) {
        results.push({ name: link.name, url: link.url });
      }

      // If there are child links (children), continue recursive search on them
      if (link.children && link.children.length > 0) {
        results.push(...this.searchLinks(link.children, query));
      }
    });

    return results;
  }
}

// Register the custom element
customElements.define('university-search', UniversitySearch);